import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aa925f16&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=aa925f16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_webpack@4.46.0__css-loader@3.6.0_webpack@4.46.0__lodash_24cgfdmwo65apd3bkbnxqthoqi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa925f16",
  null
  
)

export default component.exports